package org.hs_soft.runmynesto.domain.model.home.statistic

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class StatisticHeaderEnum : TitleEnum {
    ABC_STATISTIC,
    BILL_SEARCH;

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            ABC_STATISTIC -> strings.abcStatistic
            BILL_SEARCH -> strings.billSearch
        }
    }

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                ABC_STATISTIC -> strings.abcStatistic
                BILL_SEARCH -> strings.billSearch
            }
        }
}